import React, { useState } from 'react'
import styled from 'styled-components'
import { Tooltip } from '@mui/material'
import { RxCross1 } from "react-icons/rx";
import { setImagesToUpload } from 'features/images/imagesSlice';
import { useDispatch, useSelector } from 'react-redux';
import SpinnerSmall from 'components/SpinnerSmall';
import { useTranslation } from 'react-i18next'

export default function ImageToUploadItem(props) {
    const { t } = useTranslation('media')
    const dispatch = useDispatch()
    const { imagesToUpload } = useSelector(state => state.images)

    const handleRemove = () => {
        if(props.isLoading) return;
        const updatedImages = imagesToUpload.filter(image => image.src !== props.src);
        dispatch(setImagesToUpload(updatedImages));
    }

    return (
        <ImageItemContainer>
            {
                !props.isLoading &&
                <Tooltip placement="top" title={t('removeImage')}>
                    <RemoveImageButton
                        onClick={handleRemove}
                        >
                        <RxCross1 size={17} color='white' />
                    </RemoveImageButton>
                </Tooltip>
            }

            <img 
                src={props.src} 
                alt={props.alt || t('imageItem')}
                />
            <LoadingOverlay isLoading={props.isLoading}>
                <SpinnerSmall />
            </LoadingOverlay>
        </ImageItemContainer>
    )
}

const LoadingOverlay = styled.div`
    display: ${props => props.isLoading ? 'flex' : 'none'};
    position: absolute;
    top: 0;
    left: 0;
        width: 129px;
        height: 115px;
    background-color: rgba(0, 0, 0, 0.5);
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    z-index: 5;
`

const RemoveImageButton = styled.div`
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: #00000054;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    color: white;
    font-size: 14px;
    z-index: 10;
    cursor: pointer;
`
  
const ImageItemContainer = styled.div`
    z-index: 1;
    position: relative;

    img{
        width: 129px;
        height: 115px;
        border-radius: 6px;
        object-fit: cover;
    }
`

